import { styled } from '@linaria/react';
import { colors, fonts, primitives, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space['space-200']} 0 ${space['space-300']};
`;

export const Title = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const NavControls = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-200']};
`;

export const NavButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${semantic.text.primary};
  padding: 0;
  border-radius: 50%;
  transition: background 0.15s ease;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export const ChipsRow = styled.div`
  display: flex;
  width: 100%;
  gap: ${space['space-200']};
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  border-radius: ${size.radius['radius-sm']};

  &::-webkit-scrollbar {
    display: none;
  }

  &[data-wrap] {
    flex-wrap: wrap;
    overflow-x: visible;
  }

  &[aria-invalid='true'] {
    box-shadow: inset 0 0 0 1px ${semantic.border.danger};
  }
`;

export const Chip = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80px;
  border: 1px solid ${semantic.border.subtle};
  background: transparent;
  cursor: pointer;
  padding: ${space['space-300']} ${space['space-200']};
  font-family: ${fonts.body};
  border-radius: ${size.radius['radius-sm']};
  transition: background-color 0.15s ease, border-color 0.15s ease;
  flex-shrink: 0;
  gap: ${space['space-100']};

  &[data-selected] {
    background: ${colors.primary};
    border-color: ${colors.primary};
    color: ${semantic.text.inverse};
  }

  &:hover:not([data-selected]) {
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const ChipTime = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  line-height: ${primitives.typography.lineHeight.normal};
  color: ${(p) => (p.$selected ? semantic.text.inverse : semantic.text.primary)};
`;

export const ChipPrice = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.xxs};
  line-height: 1;
  color: ${(p) => (p.$selected ? semantic.text.inverse : semantic.text.secondary)};
  white-space: nowrap;
`;

export const ErrorRow = styled.div`
  margin-top: ${space['space-200']};
`;
